import { render, staticRenderFns } from "./create-lobby.vue?vue&type=template&id=61da483f&scoped=true&"
import script from "./create-lobby.ts?vue&type=script&lang=ts&"
export * from "./create-lobby.ts?vue&type=script&lang=ts&"
import style0 from "./create-lobby.vue?vue&type=style&index=0&lang=stylus&"
import style1 from "./create-lobby.vue?vue&type=style&index=1&id=61da483f&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61da483f",
  null
  
)

export default component.exports